import { render, staticRenderFns } from "./Stocking.vue?vue&type=template&id=a4e57570&scoped=true"
import script from "./Stocking.vue?vue&type=script&lang=js"
export * from "./Stocking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e57570",
  null
  
)

export default component.exports